import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'

// --- old formatters helpers, TODO: refactor this
import { formatContinueWatchingItem } from '~/entities/continue-watching'
import { formatLiveEventCardWithPrice } from '~/entities/live-events/events'
import { formatVodBundleInfoToUi } from '~/entities/movies/bundles'
import { formatPartnerProductItem } from '~/entities/partner-product'
import { formatBundleRowWithContent } from '~/entities/shows/bundles'
import { formatTvBundleRowWithContent } from '~/entities/tv/bundles'
import { CONTENT } from '~/features/appearance/components'
import { logger } from '~/shared/logger'
import {
  extendMediaItemByLabelPrice,
  extendMediaItemByLabelPriceTvChannel,
} from '~/shared/tools'
// ---

// Prepare items for view/ui components
export function adjustRowItem(contentType, item, adjustFactory, t) {
  if (!adjustFactory) throw new Error('Missing adjustFactory.')

  let adjust: AdjustPurchaseableFn

  switch (contentType) {
    case CONTENT.VOD: {
      adjust = adjustFactory('vod', 'vodSet')
      return extendMediaItemByLabelPrice(adjust(item))
    }
    case CONTENT.TV_CHANNEL: {
      adjust = adjustFactory('channel', 'channelSet')
      return extendMediaItemByLabelPriceTvChannel(adjust(item))
    }
    case CONTENT.TV_SHOW: {
      adjust = adjustFactory('tvShow', 'tvShowSet')
      return extendMediaItemByLabelPrice(adjust(item))
    }
    case CONTENT.LIVE_EVENT: {
      adjust = adjustFactory('liveEvent')
      return formatLiveEventCardWithPrice(adjust(item))
    }
    case CONTENT.MIXED: {
      return formatContinueWatchingItem(item, t)
    }
    case CONTENT.PARTNER_PRODUCT: {
      adjust = adjustFactory('partnerProduct')
      return formatPartnerProductItem(adjust(item))
    }
    case CONTENT.VOD_BUNDLE: {
      adjust = adjustFactory('vodSet', 'vodSet')
      return formatVodBundleInfoToUi(t, adjust)(item)
    }
    case CONTENT.TV_BUNDLE: {
      adjust = adjustFactory('channelSet', 'channelSet')
      return formatTvBundleRowWithContent(t, adjust)(item)
    }
    case CONTENT.TV_SHOW_BUNDLE: {
      adjust = adjustFactory('tvShowSet', 'tvShowSet')
      return formatBundleRowWithContent(t, adjust)(item)
    }
    case CONTENT.MOTN_VOD:
    case CONTENT.MOTN_TV_SHOW: {
      return item
    }
    default: {
      logger.warn(`Unhandled row type: ${item.type}`)
      return undefined
    }
  }
}
